// Converted to typescript through help of ChatGPT

import { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
import { Record as ImRecord, RecordOf as ImRecordOf, Map as ImmutableMap } from 'immutable';

// ================================================================================================
// DocumentsStore
// ================================================================================================

export const DOCUMENTS_REDUCER_KEY = 'documentStore';
export type DOCUMENTS_REDUCER_KEY = typeof DOCUMENTS_REDUCER_KEY;

export type DocumentsStore = QcsSyncResourceStore<DocumentProps> & {
  lastSyncDate?: string | null | undefined;
  loadPending?: boolean;
  isLoading?: boolean;
};

export const mkDocumentsStore = ImRecord({
  resourcesById: ImmutableMap<string, Document>(),

  lastSyncDate: null as string | null,
  loadPending: true,
  isLoading: false,
});

export type DocumentProps = {
  id: string | null;
  isDeleted?: boolean;
  name: string | null;
  description?: string | null;
  documentType?: string;
  contentType?: string | null;
  documentSize?: number;
  clientId?: string | null;
  url: string | null;
  size?: number;
};

export type Document = ImRecordOf<DocumentProps>;

const DocumentRecordFactory = ImRecord<DocumentProps>({
  id: null,
  isDeleted: false,
  name: null,
  description: null,
  documentType: 'OTHER',
  contentType: null,
  documentSize: 0,
  clientId: null,
  url: null,
  size: 0,
});

export const mkDocument = (values?: Partial<DocumentProps>): ImRecordOf<DocumentProps> =>
  DocumentRecordFactory(values) as ImRecordOf<DocumentProps>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [DOCUMENTS_REDUCER_KEY]: DocumentsStore;
  }
}
